<script>
export default {
  props: {
    label: { type: String, required: true },
    id: { type: String, default: '' },
    errors: { type: Array, default: () => [] },
  },
}
</script>

<template>
  <div>
    <label :for="id">{{ label }}</label>
    <slot :id="id" />
    <p v-if="errors.length" class="text-red-500 text-xs italic mt-2">
      {{ errors[0] }}
    </p>
  </div>
</template>
